// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingProvider_container__WwioO"};